import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {viewEmployeeReady,employeesIdForAction} from '../redux/employees'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'


//import DateTimeField from "react-bootstrap-datetimepicker";

import * as Helpers from '../../../common/helpers'


//import {Cities,Designations,Categories,RAG,Vaccination,WorkLocations,Departments,Employees,Gender,WorkLocationType,Kitchens,Status,AccountType,LoginType} from './DropDowns/index'

class ViewEmployee extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        employeeData:{},

        subTitle: Constants.VIEW_EMPLOYEE,

    }

    this.isComponentStillMounted = true  

}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(viewEmployeeReady(false))

    if (this.props.employees && this.props.employees.employeesSelectedId && this.props.employees.employeesSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.VIEW_EMPLOYEE))
        this.setState({
            subTitle: "View Employee",
            editFlag:true
        })
        this.getEmployeeViewById(this.props.employees.employeesSelectedId)

    } else {
        this.props.history.goBack()
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()

}

componentDidMount() {
        

}

 editEmployee = (id) => {
        if (id) {
            this.props.dispatch(employeesIdForAction(id))
            this.props.history.push("/dashboard/employees/addEdit")
        } else {
            this.dialog.show({
                title: "Employees Identification number not found",
                body: 'Employees id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


getEmployeeViewById = (id) => {
    apiService.getEmployeeViewById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        employeeData: responseData.data,                                   
                    })
                    
                    this.props.dispatch(viewEmployeeReady(true))
                }else{

                    this.props.dispatch(viewEmployeeReady(true))
                    this.props.history.goBack()
                }

            }else{

                    this.props.dispatch(viewEmployeeReady(true))
                this.props.history.goBack()
            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(viewEmployeeReady(true))
        })
}



    render() {
        return (
        <div className="line-item-edit">
               <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                   <div className="col-md-6">
                       <a href="" 
                          onClick={(e) => {e.preventDefault() 
                       this.props.history.goBack()}}> 
                       <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                       </a>
                    </div>

                      {(() => {
                                                if(this.state.employeeData.status==="ACTIVE" && Helpers.checkPrivileges("/dashboard/employees/addEdit",this.props.user)){
                                                    return(
                                                        <div className="col-md-6">
                                                           <a style={{"float":"right"}} href="" 
                                                              onClick={(e) => {e.preventDefault() 
                                                           this.editEmployee(this.state.employeeData.id)}}> 
                                                           <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit Employee
                                                           </a>
                                                        </div>
                                                    )
                                                }
                                            })()}    
                    
            </div>
            <Dialog ref={el =>
            this.dialog = el} />
            <section className="content">
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight,overflow: "auto"}} >
                    <div className="box box-info" style={{ borderTop: "0px" }}>
                        <div className="box-header with-border">
                            <h3 className="box-title" style={{ fontWeight: 600 }}>Basic Information</h3>
                        </div>
                        <div className="form-horizontal">
                            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Full Name :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.name && this.state.employeeData.name!=="" && this.state.employeeData.name!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.name}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee ID :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.code && this.state.employeeData.code!=="" && this.state.employeeData.code!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.code}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>              
                                
                                </div>


                                <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Gender :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.gender && this.state.employeeData.gender!=="" && this.state.employeeData.gender!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.gender}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Email ID :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.email && this.state.employeeData.email!=="" && this.state.employeeData.email!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.email}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>              
                                
                                </div>


                                <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Primary Mobile :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.mobile && this.state.employeeData.mobile!=="" && this.state.employeeData.mobile!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.mobile}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>D.O.B :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.dob && this.state.employeeData.dob!=="" && this.state.employeeData.dob!==undefined){
                                                    return(
                                                        <p>{Helpers.getDateFormatForUTC(this.state.employeeData.dob)}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>              
                                
                                </div>


                                <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Alternative Mobile :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.alt_mobile && this.state.employeeData.alt_mobile!=="" && this.state.employeeData.alt_mobile!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.alt_mobile}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>D.O.J :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.doj && this.state.employeeData.doj!=="" && this.state.employeeData.doj!==undefined){
                                                    return(
                                                        <p>{Helpers.getDateFormatForUTC(this.state.employeeData.doj)}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>              
                                
                                </div>


                                <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Communication Address :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.address && this.state.employeeData.address!=="" && this.state.employeeData.address!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.address}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                        
                                
                                </div>

                                
                            </div>
                        </div>
                    </div>

                    <div className="box box-info" style={{ borderTop: "0px" }}>
                        <div className="box-header with-border">
                            <h3 className="box-title" style={{ fontWeight: 600 }}>Employment Information</h3>
                        </div>
                        <div className="form-horizontal">
                            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                <div className="col-md-12 col-sm-12 col-xs-12">

                                   
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Department :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.department && this.state.employeeData.department.name && this.state.employeeData.department.name!=="" && this.state.employeeData.department.name!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.department.name}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>

                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                          <div className="form-group">
                                             <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Department Team:</label>
                                             <div className="col-sm-9">
                                                {(() => {
                                                    if(this.state.employeeData.department_team && this.state.employeeData.department_team.name && this.state.employeeData.department_team.name!=="" && this.state.employeeData.department.name!==undefined){
                                                        return(
                                                            <p>{this.state.employeeData.department_team.name}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                })()}                                         
                                             </div>
                                          </div>
                                     </div>

                                </div>

                                <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Designation :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.designation && this.state.employeeData.designation.name && this.state.employeeData.designation.name!=="" && this.state.employeeData.designation.name!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.designation.name}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reporting Manager :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.reporting_manager && this.state.employeeData.reporting_manager.name && this.state.employeeData.reporting_manager.name!=="" && this.state.employeeData.reporting_manager.name!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.reporting_manager.name}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   
                                </div>


                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Work Location Type :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.work_location_type && this.state.employeeData.work_location_type && this.state.employeeData.work_location_type!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.work_location_type}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>

                                            {(() => {
                                                 if(this.state.employeeData.work_location_type && this.state.employeeData.work_location_type && this.state.employeeData.work_location_type!==undefined && this.state.employeeData.work_location_type!=="Kitchen"){
                                                        return (
                                                                "Office Location"
                                                            )
                                                 }else if(this.state.employeeData.work_location_type && this.state.employeeData.work_location_type && this.state.employeeData.work_location_type!==undefined && this.state.employeeData.work_location_type==="Kitchen"){
                                                        return (
                                                                "Kitchen Location"
                                                            )
                                                 }else{
                                                    return (
                                                                "Work Location"
                                                            )
                                                 }
                                            })()} :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                 if(this.state.employeeData.work_location_type && this.state.employeeData.work_location_type && this.state.employeeData.work_location_type!==undefined && this.state.employeeData.work_location_type!=="Kitchen"){
                                                    if(this.state.employeeData.office_work_location && this.state.employeeData.office_work_location.name && this.state.employeeData.office_work_location.name!=="" && this.state.employeeData.office_work_location.name!==undefined){
                                                        return(
                                                            <p>{this.state.employeeData.office_work_location.name}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                }else if(this.state.employeeData.work_location_type && this.state.employeeData.work_location_type && this.state.employeeData.work_location_type!==undefined && this.state.employeeData.work_location_type==="Kitchen"){
                                                    if(this.state.employeeData.kitchen_work_location && this.state.employeeData.kitchen_work_location.name && this.state.employeeData.kitchen_work_location.name!=="" && this.state.employeeData.kitchen_work_location.name!==undefined){
                                                        return(
                                                            <p>{this.state.employeeData.kitchen_work_location.name}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                }else{
                                                    return(
                                                            <p>NA</p>
                                                        )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   
                                </div>

                                <div className="col-md-12 col-sm-12 col-xs-12">

                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.city && this.state.employeeData.city.name && this.state.employeeData.city.name!=="" && this.state.employeeData.city.name!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.city.name}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Covid-19 Vaccination :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.vaccination && this.state.employeeData.vaccination && this.state.employeeData.vaccination!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.vaccination}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   
                                </div>

                                 <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Category :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.category && this.state.employeeData.category!=="" && this.state.employeeData.category!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.category}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>RAG :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.rag && this.state.employeeData.rag!=="" && this.state.employeeData.rag!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.rag}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   
                                </div>

                                 

                            </div>
                        </div>
                    </div>



                    <div className="box box-info" style={{ borderTop: "0px" }}>
                        <div className="box-header with-border">
                            <h3 className="box-title" style={{ fontWeight: 600 }}>Bank Details</h3>
                        </div>
                        <div className="form-horizontal">
                            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                 <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Account Holder Name :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.bank_details  && this.state.employeeData.bank_details.length>0  && this.state.employeeData.bank_details[0].account_holder_name && this.state.employeeData.bank_details[0].account_holder_name!=="" && this.state.employeeData.bank_details[0].account_holder_name!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.bank_details[0].account_holder_name}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Account Number :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.bank_details && this.state.employeeData.bank_details.length>0  && this.state.employeeData.bank_details[0].account_number && this.state.employeeData.bank_details[0].account_number!=="" && this.state.employeeData.bank_details[0].account_number!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.bank_details[0].account_number}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   
                                </div>

                                 <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>IFSC Code :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.bank_details && this.state.employeeData.bank_details.length>0 && this.state.employeeData.bank_details[0].ifsc_code && this.state.employeeData.bank_details[0].ifsc_code!=="" && this.state.employeeData.bank_details[0].ifsc_code!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.bank_details[0].ifsc_code}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Bank Name :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.bank_details && this.state.employeeData.bank_details.length>0 && this.state.employeeData.bank_details[0].bank_name && this.state.employeeData.bank_details[0].bank_name!=="" && this.state.employeeData.bank_details[0].bank_name!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.bank_details[0].bank_name}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                   
                                </div>

                                 <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Account Type :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.bank_details && this.state.employeeData.bank_details.length>0 && this.state.employeeData.bank_details[0].account_type && this.state.employeeData.bank_details[0].account_type!=="" && this.state.employeeData.bank_details[0].account_type!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.bank_details[0].account_type}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                                                      
                                </div>


                            </div>
                        </div>
                    </div>


                    <div className="box box-info" style={{ borderTop: "0px" }}>
                        <div className="box-header with-border">
                            <h3 className="box-title" style={{ fontWeight: 600 }}>Employment Status</h3>
                        </div>
                        <div className="form-horizontal">
                            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                <div className="col-md-12 col-sm-12 col-xs-12">
                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                      <div className="form-group">
                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status :</label>
                                         <div className="col-sm-9">
                                            {(() => {
                                                if(this.state.employeeData.status && this.state.employeeData.status!=="" && this.state.employeeData.status!==undefined){
                                                    return(
                                                        <p>{this.state.employeeData.status}</p>
                                                    )
                                                }else{
                                                    return(
                                                        <p>NA</p>
                                                    )
                                                }
                                            })()}                                         
                                         </div>
                                      </div>
                                   </div>
                                                                      
                                </div>


                                {(() => {

                                    if(this.state.employeeData.employee_attritions && this.state.employeeData.employee_attritions.length>0 && this.state.employeeData.status==="IN ACTIVE"){

                                    return(
                                    <div>

                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                       <div className="col-md-6 col-sm-12 col-xs-12">
                                          <div className="form-group">
                                             <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Last Working Date :</label>
                                             <div className="col-sm-9">
                                                {(() => {
                                                    if(this.state.employeeData.employee_attritions[0].last_working_day && this.state.employeeData.employee_attritions[0].last_working_day!=="" && this.state.employeeData.employee_attritions[0].last_working_day!==undefined){
                                                        return(
                                                            <p>{Helpers.getDateFormatForUTC(this.state.employeeData.employee_attritions[0].last_working_day)}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                })()}                                         
                                             </div>
                                          </div>
                                       </div>
                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                          <div className="form-group">
                                             <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Removed From WhatsAppp Group :</label>
                                             <div className="col-sm-9">
                                                {(() => {
                                                    if(this.state.employeeData.employee_attritions[0].group_excluded && this.state.employeeData.employee_attritions[0].group_excluded!=="" && this.state.employeeData.employee_attritions[0].group_excluded!==undefined){
                                                        return(
                                                            <p>{this.state.employeeData.employee_attritions[0].group_excluded}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                })()}                                         
                                             </div>
                                          </div>
                                       </div>
                                                                          
                                    </div>

                                     <div className="col-md-12 col-sm-12 col-xs-12">
                                       <div className="col-md-6 col-sm-12 col-xs-12">
                                          <div className="form-group">
                                             <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason :</label>
                                             <div className="col-sm-9">
                                                {(() => {
                                                    if(this.state.employeeData.employee_attritions[0].reason_id && this.state.employeeData.employee_attritions[0].reason_id!=="" && this.state.employeeData.employee_attritions[0].reason_id!==undefined){
                                                        return(
                                                            <p>{this.state.employeeData.employee_attritions[0].reason_id}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                })()}                                         
                                             </div>
                                          </div>
                                       </div>
                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                          <div className="form-group">
                                             <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Manager Remarks :</label>
                                             <div className="col-sm-9">
                                                {(() => {
                                                    if(this.state.employeeData.employee_attritions[0].manager_remarks && this.state.employeeData.employee_attritions[0].manager_remarks!=="" && this.state.employeeData.employee_attritions[0].manager_remarks!==undefined){
                                                        return(
                                                            <p>{this.state.employeeData.employee_attritions[0].manager_remarks}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                })()}                                         
                                             </div>
                                          </div>
                                       </div>
                                                                          
                                    </div>

                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                       <div className="col-md-6 col-sm-12 col-xs-12">
                                          <div className="form-group">
                                             <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Attrition Date :</label>
                                             <div className="col-sm-9">
                                                {(() => {
                                                    if(this.state.employeeData.employee_attritions[0].created && this.state.employeeData.employee_attritions[0].created!=="" && this.state.employeeData.employee_attritions[0].created!==undefined){
                                                        return(
                                                            <p>{Helpers.getDateFormatForUTC(this.state.employeeData.employee_attritions[0].created)}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                })()}                                         
                                             </div>
                                          </div>
                                       </div>   
                                                                          
                                    </div>

                                    </div>  

                                    )


                                    }
                                })()} 

                            </div>
                        </div>
                    </div>


    {(() => {

            if(this.state.employeeData.users && this.state.employeeData.users.length>0){

                return(

                    <div className="box box-info" style={{ borderTop: "0px" }}>
                        <div className="box-header with-border">
                            <h3 className="box-title" style={{ fontWeight: 600 }}>Login Deatils</h3>
                        </div>
                        <div className="form-horizontal">
                            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                <div className="col-md-12 col-sm-12 col-xs-12">
                                       <div className="col-md-6 col-sm-12 col-xs-12">
                                          <div className="form-group">
                                             <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Username :</label>
                                             <div className="col-sm-9">
                                                {(() => {
                                                    if(this.state.employeeData.users[0].username && this.state.employeeData.users[0].username!=="" && this.state.employeeData.users[0].username!==undefined){
                                                        return(
                                                            <p>{this.state.employeeData.users[0].username}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                })()}                                         
                                             </div>
                                          </div>
                                       </div>
                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                          <div className="form-group">
                                             <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>User Type :</label>
                                             <div className="col-sm-9">
                                                {(() => {
                                                    if(this.state.employeeData.users[0].user_type && this.state.employeeData.users[0].user_type!=="" && this.state.employeeData.users[0].user_type!==undefined){
                                                        return(
                                                            <p>{this.state.employeeData.users[0].user_type}</p>
                                                        )
                                                    }else{
                                                        return(
                                                            <p>NA</p>
                                                        )
                                                    }
                                                })()}                                         
                                             </div>
                                          </div>
                                       </div>
                                                                          
                                    </div>

                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                    {(() => {

                                        if(this.state.employeeData.users[0].user_roles && this.state.employeeData.users[0].user_roles.length>0){

                                            return(

                                                <div className="box box-info" style={{ borderTop: "0px" }}>
                                                    <div className="box-header with-border">
                                                        <h3 className="box-title" style={{ fontWeight: 600 }}>User Roles</h3>
                                                    </div>
                                                    <div className="form-horizontal">
                                                        <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                                            <table className="table table-sm thead-dark table-bordered" style={{textAlign:"left",width:"30%"}}>
                                                              <thead style={{background:"#146d59",color:"white"}}>
                                                                 <tr>
                                                                    <th>Role Name</th>
                                                                 </tr>
                                                              </thead>
                                                              <tbody>
                                                                 {this.state.employeeData.users[0].user_roles.map((item, index) => (
                                                                 <tr>
                                                                    <td>{item.role.name}</td>
                                                                 </tr>
                                                                 ))}
                                                              </tbody>
                                                           </table>


                                                        </div>
                                                    </div>
                                                </div>

                                                )
                                            }
                                    })()} 
                                    </div>

                            </div>
                        </div>
                    </div>

                )
            }
     })()} 


                </div>
            </div>
            </section>
        </div>
        )
    }

   
}
function mapStateToProps(state) {
    return {
        employees: state.employees,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(ViewEmployee))


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/ViewEmployee.js